import script from "./ContentPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentPreview.vue?vue&type=script&setup=true&lang=ts"

import "./ContentPreview.vue?vue&type=style&index=0&id=7b005635&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b005635"]])

export default __exports__